import { render, staticRenderFns } from "./TestResultFormV2.vue?vue&type=template&id=59be67ce"
import script from "./TestResultFormV2.vue?vue&type=script&lang=js"
export * from "./TestResultFormV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports